module.exports = __webpack_public_path__ + "static/media/nb_akademie_black_italic-webfont.bb0979d1.ttf";